import axios from "../axios";
const END_POINT = "/users";

const registerUser = (patient) => axios.post(`${END_POINT}`, patient);
const editUser = (user, id) => axios.patch(`${END_POINT}/${id}`, user);
const updateUserFromLegalMedicalRecord = (user, id) =>
  axios.patch(`${END_POINT}/legal-medical-record/${id}`, user);
const findUser = (id) => axios.get(`${END_POINT}/${id}`);
const getUsers = (payload) => {
  axios.get(`${END_POINT}?page=${payload.page}&limit=${payload.limit}`);
};
const searchUsers = (user) => axios.post(`${END_POINT}/search`, user);
const uploadDocs = (payload, id) => {
  return axios.post(`${END_POINT}/attach-files/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const editDocs = (payload, id) => {
  return axios.patch(`${END_POINT}/attach-files/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const removeDocs = (payload, id) => {
  return axios.delete(`${END_POINT}/attach-files/${id}`, { data: payload });
};
const changePassword = (pass) =>
  axios.post(`${END_POINT}/change-password`, pass);
  const findUserToday = (id) => axios.get(`${END_POINT}/get-patient-turn-today-for-current-day/${id}`);

export {
  searchUsers,
  registerUser,
  changePassword,
  getUsers,
  editUser,
  findUser,
  uploadDocs,
  editDocs,
  removeDocs,
  findUserToday,
  updateUserFromLegalMedicalRecord,
};
